import React, { useState, useEffect } from 'react';
import moment from "moment-timezone";
import * as _ from 'lodash';

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Box, Checkbox, Grid, LinearProgress, TableBody } from "@material-ui/core";
import { TableCell, TableFooter, TablePagination, TableRow } from '@material-ui/core';
import InputSearch from 'components/Input/InputSearch';
import AppUtil from 'utilities/AppUtil';
// import { getAuthInfo } from 'store/slices/auth';
import AppTable from '../../Table/AppTable';
import TablePaginationActions from '../../Table/TablePaginationActions';
import { Field, Form, Formik } from 'formik';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import { fetchListTimesheet } from 'store/slices/booking';
import { getTimesheetList } from 'store/slices/booking';
import AppColor from 'utilities/AppColor';
import { getAuthInfo } from 'store/slices/auth';
import { SYSTEM_ROLE } from 'config/AppConfig';
import AppButton from 'components/CustomButtons/AppButton';
import { reduceAddPayrollByWorkerList } from 'store/slices/payroll';
import AppWarningDialog from 'components/Dialog/AppWarningDialog';
import AppDialog from 'components/Dialog/AppDialog';
import ResultPayrollTable from './component/ResultPayrollTable';
import Loading from 'components/Common/Loading';


const headCells = [
  {
    id: "name",
    numeric: "left",
    disablePadding: false,
    label: "label.staffName",
    sort: true,
  },
  {
    id: "email",
    numeric: "left",
    disablePadding: false,
    label: "label.staffEmail",
    sort: true,
  },
  {
    id: "totalHours",
    numeric: "center",
    disablePadding: false,
    label: "label.totalHours",
    sort: true,
  },
  {
    id: "totalKm",
    numeric: "center",
    disablePadding: false,
    label: "label.totalKm",
    sort: true,
  },
  {
    id: "totalReimbursement",
    numeric: "center",
    disablePadding: false,
    label: "label.totalReimbursementTimesheet",
    sort: true,
  },
];

const STYLE = {
  labelFromToDate: {
    display: "flex",
    alignItems: 'flex-start',
    justifyContent: "flex-end",
    minWidth:'80px', 
    margin:'0.3rem 5px 0 0', 
    fontWeight: 'bold'
  },
  hyperLink: {
    color: AppColor.blue,
    textDecoration: 'underline'
  }
}

const TimesheetTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [queries, setQueries] = useState({
    is_asc: false,
    page_number: 1,
    page_size: 10,
    search_key: "",
    sort_field: "created_date",
    startDate: '',
    endDate: '',
  });

  const userInfo = useSelector(getAuthInfo);
  const timesheetList = useSelector(getTimesheetList);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataResultPayroll, setDataResultPayroll] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [selected, setSelected] = useState([]);
  const [showWarningModal, setWarningShowModal] = useState(false);
  const [showResultPayrollModal, setShowResultPayrollModal] = useState(false);
  const [isCreatePayroll, setIsCreatePayroll] = useState(false);
  
  const emptyRows = data.length === 0;

  const handleChangePage = (event, newPage) => {
    _loadData({ ...queries, page_number: newPage + 1 });
    AppUtil.scrollToTopById("main-panel");
  };

  const handleChangeRowsPerPage = (event) => {
    _loadData({
      ...queries,
      page_number: 1,
      page_size: parseInt(event.target.value),
    });
    AppUtil.scrollToTopById("main-panel");
  };

  const onRequestSort = (event, property) => {
    _loadData({
      ...queries,
      sort_field: property,
      is_asc:
        ( property === 'title' ||
          property === queries.sort_field) ? queries.is_asc !== true : true,
    });
  };

  const onSearch = (value) => {
    _loadData({
      ...queries,
      search_key: value,
      page_number: 1,
    });
    setSelected([]);
  };

  const _loadData = async ({ page_number, page_size, search_key, is_asc, sort_field, startDate, endDate } = {}) => {
    const newQueries = {
      ...queries,
    };
    if (page_number) {
      newQueries.page_number = page_number;
    }
    if (page_size) {
      newQueries.page_size = page_size;
    }
    if (sort_field) {
      newQueries.sort_field = sort_field;
    }
    newQueries.search_key = search_key || "";
    newQueries.is_asc = !(!is_asc || false);
    if (startDate || startDate === '') {
      newQueries.startDate = (startDate === '') ? '' : moment(startDate).format('YYYY/MM/DD') ;
    }
    if (endDate || endDate === '') {
      newQueries.endDate = (endDate === '') ? '' :moment(endDate).format('YYYY/MM/DD');
    }
    
    setLoading(true);
    dispatch(fetchListTimesheet({...newQueries}))
      .then(({ payload }) => {
        setQueries(newQueries);
        setLoading(false);
        if (payload) {
          setTotalElements(payload.totalElements);
        }
      });
  };
  
  const _handleSelect = (id) => {
    if (!selected.includes(id)) {
        setSelected([...selected, id]);
    } else {
        setSelected(selected.filter(item => item !== id))
    }
  }

  const _handleSelectAll = () => {
    if (data.length === countSelectInPage()) {
        setSelected([]);
    } else {
        setSelected(_.union(selected, data.map(item => item.workerId)));
    }
  }

  const _handleCreatePayroll = async () => {
    if (loading) {
      return;
    }
    if (queries.startDate === '' || queries.endDate === '' || selected.length === 0 ) {
      setWarningShowModal(true);
      return;
    }
    const startDate = AppUtil.formatDate(queries.startDate, 'yyyy/MM/DD');
    const endDate = AppUtil.formatDate(queries.endDate, 'yyyy/MM/DD');

    const params = { startDate, endDate, workerIdList: selected};
    setIsCreatePayroll(true);
    const { payload } = await dispatch(reduceAddPayrollByWorkerList(params));
    if (payload) {
      setDataResultPayroll(payload);
      setSelected([]);
      setShowResultPayrollModal(true);
    }
    setIsCreatePayroll(false);
  }

  useEffect(() => {
    if (userInfo.role !== SYSTEM_ROLE.COMPANY) {
      history.push('/');
      return;
    }
    _loadData(queries);
  }, []);

  useEffect(() => {
    if (timesheetList){
      setData(timesheetList);
    }
  }, [timesheetList])

  const handleFromDateChange = (startDate) => {
    _loadData({...queries, startDate, page_number: 1});
    setSelected([]);
  }
  const handleToDateChange = (endDate) => {
    _loadData({...queries, endDate, page_number: 1});
    setSelected([]);
  }

  const customToDate = (values) => {
    if (!values.fromDate || values.fromDate === '') {
      return {
        maxDate: moment().subtract(1, 'days').toDate()
      };
    }
    return {
      minDate: new Date(moment(values.fromDate).add(1, "days")),
      maxDate: moment().subtract(1, 'days').toDate()
    };
  }

  const customFromDate = (values) => {
    if (!values.toDate || values.toDate === '') {
      return {
        maxDate: moment().subtract(2, 'days').toDate()
      };
    }
    return {
      maxDate: new Date(moment(values.toDate).subtract(1, "days"))
    };
  }

  const countSelectInPage = () => {
    const list = data.filter(item => {
      for (const i in selected) {
        if (item.workerId === selected[i]) {
          return true;
        }
      }
      return false;
    });
    return list.length;
  }

  if (isCreatePayroll) {
    return (
      <Loading/>
    )
  }

  return (
    <Formik
        initialValues={{
          fromDate: queries.startDate,
          toDate: queries.endDate,
        }}
        enableReinitialize
      >
        {({values}) => (
          <Form style={{ minHeight: '450px'}}>
            <Grid container spacing={3}>
              <Grid item md={12} lg={4}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', height: '100%' }}>
                  <div  style={{ marginBottom: '1rem', width: '100%' }}>
                    <InputSearch
                      name='search'
                      onSearch={onSearch}
                      searchText={queries.search_key}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item md={10} lg={6}>
                <Box display="flex">
                  <Box className="mr-2" style={{ maxWidth: '300px', margin: '0 0.5rem' }} >
                    <label>{t("label.fromDate")}</label>
                    <Field
                      component={CustomDatePicker}
                      name="fromDate"
                      placeholder={t("label.fromDate")}
                      formatDateJob={true}
                      onChange={(event) => {handleFromDateChange(event)}}
                      custom={customFromDate(values)}
                    />
                  </Box>
                  <Box className="mr-2" style={{ maxWidth: '300px', margin: '0 0.5rem' }}>
                    <label>{t("label.toDate")}</label>
                    <Field
                      component={CustomDatePicker}
                      name="toDate"
                      placeholder={t("label.toDate")}
                      formatDateJob={true}
                      onChange={(event) => {handleToDateChange(event)}}
                      custom={customToDate(values)}
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid item lg={2}  style={{ display: 'flex', justifyContent: 'flex-end',  alignItems: 'flex-end' }}>
                <Box className="mr-2" style={{ marginBottom: '1rem' }}>
                  <AppButton
                    label={t('label.createPayroll')}
                    onClick={() => _handleCreatePayroll()}
                    disabled={loading}
                  />
                </Box>
              </Grid>
            </Grid>
              <AppTable
                onRequestSort={onRequestSort}
                order={queries.is_asc === true ? "asc" : "desc"}
                orderBy={queries.sort_field === 'workerName' ? 'workerName' : queries.sort_field}
                headCells={headCells}
                rowCount={data.length}
                numSelected={countSelectInPage()}
                onSelectAllClick={_handleSelectAll}
              >
                <TableBody>
                  {loading && (<TableRow>
                    <TableCell colSpan={headCells.length + 1} padding="none">
                      <LinearProgress />
                    </TableCell>
                  </TableRow>)}
                  {data.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell padding="checkbox">
                        <Checkbox
                            checked={selected.indexOf(row.workerId) !== -1}
                            inputProps={{ 'aria-labelledby': row.workerId }}
                            onClick={() => _handleSelect(row.workerId)}
                            color="primary"
                        />
                      </TableCell>
                      <TableCell style={STYLE.hyperLink} title={row.workerFullName}>
                        <Link
                            to={`/admin/financial/timesheet/${row.workerId}`}
                            className="text-left"
                        >
                          {AppUtil.shortenText(row.workerFullName)}
                        </Link>
                      </TableCell>
                      
                      <TableCell >{row.workerEmail}</TableCell>
                      <TableCell align='center'>
                        {row.totalHours && row.totalHours !== 0 ? AppUtil.formatNumber(row.totalHours) : '-'}
                      </TableCell>
                      <TableCell align='center'>
                        {row.totalKm && row.totalKm !== 0 ? AppUtil.formatNumber(row.totalKm) : '-'}
                      </TableCell>
                      <TableCell align='center'>
                        {row.totalReimbursement && row.totalReimbursement !== 0 ? t('price.iconPrice', {value: AppUtil.formatMoney(row.totalReimbursement)}) : '-'}
                      </TableCell>
                    </TableRow>
                  ))}

                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 }}>
                      <TableCell colSpan={headCells.length} className="text-center">
                        {t("label.no_data")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      colSpan={headCells.length}
                      count={totalElements}
                      rowsPerPage={queries.page_size}
                      page={queries.page_number - 1}
                      SelectProps={{
                        inputProps: { "aria-label": "rows per page" },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                      labelRowsPerPage={`${t("label.rows_per_page")}:`}
                      labelDisplayedRows={({ from, to, count }) =>
                        t("label.from_to", {
                          from,
                          to,
                          count:
                            count !== -1 ? count : `${t("text.more_than")} ${to}`,
                        })
                      }
                    />
                  </TableRow>
                </TableFooter>
              </AppTable>
            <AppWarningDialog
              open={showWarningModal}
              onClose={() => setWarningShowModal(false)}
              title={t('title.warning')}
              content={t('text.warningPayrollTimesheet')}
              cancelLabel={t('button.close')}
            />
            <AppDialog
              open={showResultPayrollModal}
              onClose={() => setShowResultPayrollModal(false)}
              title={t('title.createPayrollResult')}
              maxWidth='md'
            >
              <Box my={3} >
                <ResultPayrollTable data={dataResultPayroll} loading={loading} setShowModal={setShowResultPayrollModal} />
              </Box>
            </AppDialog>
          </Form>
        )}
    </Formik>
  );
}

export default TimesheetTable;